/**
 * The «Gestão Operacional» hub: the Suporte area's items, in tab order.
 *
 * One catalogue for the menu item, the route guard and the hub, so the three
 * never disagree on who sees what. `acls` is any-of: the item shows for
 * whoever holds one of them, and the hub for whoever sees any item.
 */
export const OPERATIONS_HUB_ITEMS = [
  {
    value: "negocios",
    label: "Negócios",
    icon: "pi pi-fw pi-briefcase",
    acls: ["seeOperationsHubDeals"],
  },
];

/** Every alias that opens at least one item, i.e. the hub itself. */
export const OPERATIONS_HUB_ACLS = [
  ...new Set(OPERATIONS_HUB_ITEMS.flatMap((item) => item.acls)),
];

/** Creates a PHC business from the «Negócios» item. */
export const OPERATIONS_HUB_CREATE_DEAL_ACL = "createOperationsHubDeals";

/** Edits a business not yet adjudicated, from its side panel. */
export const OPERATIONS_HUB_EDIT_DEAL_ACL = "editOperationsHubDeals";

/** Creates the installation of a business that has none. */
export const OPERATIONS_HUB_CREATE_INSTALLATION_ACL = "createOperationsHubInstallations";

/** Opens a PAT on a business's installation while it has none. */
export const OPERATIONS_HUB_CREATE_PAT_ACL = "createOperationsHubPats";

/** Adds files to a business; seeing them only needs to see the deal. */
export const OPERATIONS_HUB_ADD_DEAL_FILES_ACL = "addOperationsHubDealFiles";

/** The API's per-file limit (max:20480 KB), shown to the user. */
export const OPERATIONS_HUB_FILE_MAX_MB = 20;

/**
 * A business file's document type, as the lead sale files them in PHC
 * (`anexos.resumo`).
 */
export const OPERATIONS_HUB_DOCUMENT_TYPES = ["Proposta cliente", "Proposta custo", "Outros documentos"];
